import { useEffect, useState } from "react";

/** Load one Insights section, again whenever `deps` change. */
export function useSection<T>(load: () => Promise<T>, deps: unknown[]) {
  const [state, setState] = useState<{ data: T | null; error: string | null }>({
    data: null,
    error: null,
  });
  useEffect(() => {
    let active = true;
    setState({ data: null, error: null });
    load()
      .then((data) => active && setState({ data, error: null }))
      .catch(
        (e) =>
          active &&
          setState({ data: null, error: e instanceof Error ? e.message : "Couldn't load." }),
      );
    return () => {
      active = false;
    };
  }, deps);
  return state;
}

export function Loading({ error }: { error: string | null }) {
  return error ? (
    <p className="text-negative">{error}</p>
  ) : (
    <p className="text-text-muted">Loading…</p>
  );
}
